import { Injectable } from '@angular/core';
import { ApiService } from '../services/api.service';
import { Observable } from 'rxjs';
import { HttpResponse } from '@angular/common/http';
import { Payment, PaymentsListResponse } from './payments.models';
import { buildHttpParams } from '../utils';

@Injectable({
  providedIn: 'root',
})
export class PaymentsService {
  private baseUrl: string = 'payments';

  constructor(private apiService: ApiService) {}

  list(params = {}): Observable<PaymentsListResponse> {
    const q = buildHttpParams(params);
    return this.apiService.get(`${this.baseUrl}/payments/`, q);
  }

  get(id: string): Observable<Payment> {
    return this.apiService.get(`${this.baseUrl}/payments/${id}/`);
  }

  exportDetailed(params = {}): Observable<HttpResponse<Blob>> {
    const q = buildHttpParams(params);
    return this.apiService.getBlobResponse(`${this.baseUrl}/payments/export-detailed/`, q);
  }
}
